<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Nouveau contact</h2>
    <p class="page-subtitle">Ajoutez un nouveau contact à votre carnet d'adresses</p>
  </div>
  <a routerLink="/contacts" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </a>
</div>

<div class="form-container">
  <div class="card shadow-sm">
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="modern-form">
      <div class="form-section">
        <h3 class="section-title">Informations du contact</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="nom">NOM</label>
            <input type="text" id="nom" formControlName="nom" class="form-control" placeholder="ex: Dupont">
            @if (contactForm.get('nom')?.touched && contactForm.get('nom')?.errors?.['required']) {
              <div class="field-error">Le nom est requis.</div>
            }
          </div>
          <div class="form-group col">
            <label for="prenom">PRÉNOM</label>
            <input type="text" id="prenom" formControlName="prenom" class="form-control" placeholder="ex: Jean">
            @if (contactForm.get('prenom')?.touched && contactForm.get('prenom')?.errors?.['required']) {
              <div class="field-error">Le prénom est requis.</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="telephone">TÉLÉPHONE</label>
            <input type="text" id="telephone" formControlName="telephone" class="form-control" placeholder="ex: 0102030405">
            @if (contactForm.get('telephone')?.touched && contactForm.get('telephone')?.errors?.['telephone']) {
              <div class="field-error">Format de téléphone invalide (10 chiffres commençant par 0).</div>
            }
          </div>
          <div class="form-group col">
            <label for="email">ADRESSE EMAIL</label>
            <input type="email" id="email" formControlName="email" class="form-control" placeholder="ex: jean.dupont&#64;exemple.com">
            @if (contactForm.get('email')?.touched && contactForm.get('email')?.errors?.['email']) {
              <div class="field-error">Adresse email invalide.</div>
            }
          </div>
        </div>
      </div>

      @if (errorMessage()) {
        <div class="error-banner">{{ errorMessage() }}</div>
      }

      <div class="form-actions">
        <button type="button" routerLink="/contacts" class="btn btn-outline">Annuler</button>
        <button type="submit" [disabled]="contactForm.invalid || isLoading()" class="btn btn-primary">
          {{ isLoading() ? 'Création en cours...' : 'Créer le contact' }}
        </button>
      </div>
    </form>
  </div>
</div>

<style>
.field-error {
  color: #c62828;
  font-size: 12px;
  margin-top: 4px;
}
/* Rendre visuellement les boutons disabled bien grisés et inactifs */
.btn[disabled] {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
